import React from 'react'
import Switch from '@material-ui/core/Switch'

export default function CustomSwitch({ checked, handleChange }) {
  return (
    <div>
      <Switch checked={checked} onChange={handleChange} name="switch" color="primary" />
    </div>
  )
}
